<section class="hero-section" id="home">
  <div id="hero-carousel" class="carousel carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
    <div class="carousel-inner">

      <!-- Carousel Item 1 -->
      <div class="carousel-item active">
        <div class="hero-content">
          <h1>Bienvenue chez Athena Technologies</h1>
          <p>La puissance de l'intelligence artificielle à votre service</p>
          <!-- <a href="#home" class="btn btn-primary" (click)="openLoginDialog($event)">Get Started</a>-->
        </div>
      </div>

      <!-- Carousel Item 2 -->
      <div class="carousel-item">
        <div class="hero-content">
          <h1>Un service personnalise</h1>
          <p>Adapté à vos besoins, pensé pour vos objectifs</p>
          <!--   <a href="#home" class="btn btn-primary" (click)="openLoginDialog($event)">Get Started</a>-->
           </div>
         </div>

         <!-- Carousel Item 3 -->
      <div class="carousel-item">
        <div class="hero-content">
          <h1>Transformez vos donnees en valeur</h1>
          <p>Exploitez tout le potentiel de vos données avec nos solutions IA</p>
<!--          <a href="#home" class="btn btn-primary" (click)="openLoginDialog($event)">Get Started</a>-->
        </div>
      </div>
    </div>

    <!-- Carousel Controls -->
    <a class="carousel-control-prev" href="#hero-carousel" role="button" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </a>
    <a class="carousel-control-next" href="#hero-carousel" role="button" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </a>

    <!-- Carousel Indicators -->
    <ol class="carousel-indicators">
      <li data-bs-target="#hero-carousel" data-bs-slide-to="0" class="active"></li>
      <li data-bs-target="#hero-carousel" data-bs-slide-to="1"></li>
      <li data-bs-target="#hero-carousel" data-bs-slide-to="2"></li>
    </ol>
  </div>
</section>
